<template>
  <v-container fluid>
    <ControlsBar v-if="!$route.meta?.hideControlsBar" />
    <router-view />
  </v-container>
</template>

<script>
import ControlsBar from '../Components/ControlsBar.vue';

export default {
  name: 'ControlsView',
  components: {
    ControlsBar,
  },
};
</script>
